// extracted by mini-css-extract-plugin
module.exports = {"container":"headerPromotePage_container__1Udsa","image":"headerPromotePage_image__2DtDQ","overlay":"headerPromotePage_overlay__csVnI","content":"headerPromotePage_content__3b2wu","titleContent":"headerPromotePage_titleContent__S-B7_","contentBtn":"headerPromotePage_contentBtn__1igH4"};
    if(module.hot) {
      // 1790670303971
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  